(function () {
    'use strict';

    angular.module('swif.framework')


    /**
        * @ngdoc service
        * @name swif.framework.swifFrameworkService
        * @description this is a facade to all services inside swif.framework
        *
        * ```js
          {
            route,
            debug,
            action,
            attachment,
            alerter,
            available,
            cart,
            collections,
            collection,
            data,
            date,
            email,
            sms,
            filter,
            form,
            fullcalendar,
            i18n,
            message,
            modal,
            module,
            panel,
            settings,
            state,
            user,
            validation,
            resources
          }```
        * @requires  swif.framework.actionService
        * @requires  swif.framework.AttachmentService
        * @requires  swif.framework.swifAlerter
        * @requires  swif.framework.swifAvailableService
        * @requires  swif.framework.collections
        * @requires  swif.framework.dataService
        * @requires  swif.framework.swifMomentUtility
        * @requires  swif.framework.swifFormUtility
        * @requires  swif.framework.msgService
        * @requires  swif.framework.swifModal
        * @requires  swif.framework.settingsService
        * @requires  swif.framework.userService
        * @requires  swif.framework.swifPanelService
        * @requires  swif.framework.swifModule
        * @requires  swif.framework.swifFilterService
        * @requires  swif.framework.swifFrameworkCartService
        * @requires  swif.framework.gettextCatalog
        * @requires  swif.framework.swifEmailService
        * @requires  swif.framework.swifSmsService
        * @requires  swif.framework.swifStateService
        * @requires  swif.framework.swifFullCalendarService
        * @requires  swif.framework.swifValidationService
        * @requires  swif.framework.swifRouteService
        * @requires  swif.framework.swifResourcesService
    **/
    .factory('swifFrameworkService', swifFrameworkService);
    function swifFrameworkService(
        $location,
        actionService,
        AttachmentService,
        swifAlerter,
        swifAvailableService,
        collections,
        CacheService,
        dataService,
        swifMomentUtility,
        swifFormUtility,
        msgService,
        swifModal,
        settingsService,
        userService,
        swifPanelService,
        swifModule,
        swifFilterService,
        swifFrameworkCartService,
        gettextCatalog,
        swifEmailService,
        swifSmsService,
        swifStateService,
        swifFullCalendarService,
        swifValidationService,
        swifRouteService,
        swifResourcesService,
        swifDownloadService,
        swifStatisticsService
    ) {
        'ngInject';
        var service = {};
        service.$location = $location;
        service.route = swifRouteService;
        service.statistics = swifStatisticsService;
        service.debug = $location.search().debug || false;
        service.action = actionService;
        service.attachment = AttachmentService;
        service.alerter = swifAlerter;
        service.available = swifAvailableService;
        service.cart = swifFrameworkCartService;
        service.cache = CacheService;
        service.collections = collections;
        service.collection = collections;
        service.data = dataService;
        service.date = swifMomentUtility;
        service.email = swifEmailService;
        service.sms = swifSmsService;
        service.filter = swifFilterService;
        service.form = swifFormUtility;
        service.fullcalendar = swifFullCalendarService;
        service.i18n = gettextCatalog;
        service.message = msgService;
        service.modal = swifModal;
        service.module = swifModule;
        service.panel = swifPanelService;
        service.settings = settingsService;
        service.state = swifStateService;
        service.user = userService;
        service.validation = swifValidationService;
        service.resources = swifResourcesService;
        service.download = swifDownloadService;
        return service;
    }

})();
